// GPA Page
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

const GPAPage = () => {
  const [gpa, setGpa] = useState('Loading...');

  useEffect(() => {
    const run = async () => {
      try {
        const snap = await getDocs(collection(db, 'grades'));
        const all = snap.docs.map(d => ({ id: d.id, ...d.data() }));

        // Keep only most recent per className
        const latestByClass = {};
        for (const g of all) {
          if (!g.className || g.overallPercent == null) continue; // skip invalid
          const t = new Date(g.date || g.createdAt || 0).getTime();
          const prev = latestByClass[g.className];
          if (!prev || t > new Date(prev.date || prev.createdAt || 0).getTime()) {
            latestByClass[g.className] = g;
          }
        }

        const latest = Object.values(latestByClass);
        // Exclude classes with missing overallPercent
        const usable = latest.filter(g => typeof g.overallPercent === 'number');
        if (usable.length === 0) {
          setGpa('No grades available');
          return;
        }

        // Percent -> 4.0 scale (simple A=4, B=3, C=2, D=1, F=0)
        const toGpa = (p) => (p >= 90 ? 4 : p >= 80 ? 3 : p >= 70 ? 2 : p >= 60 ? 1 : 0);

        const values = usable.map(g => toGpa(g.overallPercent));
        // Debug output
        console.log('Latest per class:', usable.map(g => ({ class: g.className, percent: g.overallPercent, gpa: toGpa(g.overallPercent) })));

        const sum = values.reduce((a, b) => a + b, 0);
        const avg = sum / values.length;
        setGpa(avg.toFixed(2));
      } catch (e) {
        console.error('GPA calc error', e);
        setGpa('Error');
      }
    };
    run();
  }, []);

  return (
    <div style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh', fontFamily: 'monospace', fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {gpa}
    </div>
  );
};

export default GPAPage;
